import { createFileRoute, redirect } from '@tanstack/react-router'
import { SELLERS_PAGE_READ, SELLERS_TABS } from '~/components/routes/sellers/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { firstAuthorizedScreen } from '~/utils/rbacModuleIndex'

// Chaque onglet est une URL distincte ; /sellers redirige vers le premier onglet accessible
// directement au chargement de la route.
export const Route = createFileRoute('/_authenticated/sellers/')({
  staticData: {
    permission: SELLERS_PAGE_READ,
  },
  beforeLoad: ({ context }) => {
    const first = firstAuthorizedScreen(context.ability, SELLERS_TABS)
    throw redirect({ to: first?.to ?? SELLERS_TABS[0].to })
  },
})
withRoutePermissions(Route)
